import * as React from "react";
import { SVGProps, memo } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}

const SvgComponent = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 52 46"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g fill="#111827" clipPath="url(#a)">
      <path d="M7.4 34.85c.004.165.029.329.075.487l.15.375a.15.15 0 0 1 .037.113c0 .075-.037.112-.075.188l-.375.224H7.1a.224.224 0 0 1-.188-.075.674.674 0 0 1-.187-.262 2.098 2.098 0 0 1-.188-.3 2.025 2.025 0 0 1-1.612.75 1.5 1.5 0 0 1-1.088-.413 1.425 1.425 0 0 1-.412-1.05 1.463 1.463 0 0 1 .525-1.124 1.95 1.95 0 0 1 1.312-.413h.6l.638.112v-.337a1.312 1.312 0 0 0-.263-.862 1.425 1.425 0 0 0-.9-.263l-.6.075-.6.188-.187.075h-.075c-.075 0-.113-.075-.113-.188v-.262A.263.263 0 0 1 3.8 31.7l.15-.113a2.81 2.81 0 0 1 .675-.224c.281-.075.571-.112.862-.113a2.062 2.062 0 0 1 1.463.45 1.838 1.838 0 0 1 .45 1.35v1.8Zm-2.213.825.563-.112c.196-.077.374-.192.525-.338.085-.113.148-.24.187-.375 0-.113.038-.263.038-.45v-.225l-.488-.112h-.525a1.275 1.275 0 0 0-.825.224.788.788 0 0 0-.262.638.787.787 0 0 0 .187.563.786.786 0 0 0 .6.187Zm4.388.6a.224.224 0 0 1-.188-.075.337.337 0 0 1-.15-.225l-1.275-4.238a.675.675 0 0 1-.037-.224.112.112 0 0 1 .07-.104.112.112 0 0 1 .042-.009h.75a.6.6 0 0 1 .113.225l.937 3.638.863-3.638a.299.299 0 0 1 .075-.225h.9l.112.225.863 3.675.938-3.675.112-.225h.713c.112 0 .15.038.15.113v.112c0 .038-.038.075-.038.113l-1.35 4.275a.226.226 0 0 1-.113.187l-.187.075h-.488a.263.263 0 0 1-.3-.3l-.862-3.525-.862 3.525a.3.3 0 0 1-.075.225l-.226.075h-.487Zm7.05.15c-.279 0-.556-.038-.825-.112l-.638-.226a.412.412 0 0 1-.187-.15c0-.037-.037-.112-.037-.15v-.3a.15.15 0 0 1 .15-.15h.075l.15.075.6.188.674.075c.275.009.547-.056.788-.188a.6.6 0 0 0 .3-.525.563.563 0 0 0-.15-.375 1.313 1.313 0 0 0-.563-.3l-.787-.262a1.724 1.724 0 0 1-.9-.525 1.35 1.35 0 0 1-.263-.825c-.009-.21.043-.419.15-.6.082-.182.212-.337.375-.45l.6-.3.675-.075h.713l.338.113.224.075c.076.037.113.112.15.15a.263.263 0 0 1 .038.187v.263c0 .112-.037.15-.112.15a.224.224 0 0 1-.188-.076 3.3 3.3 0 0 0-1.088-.187 1.35 1.35 0 0 0-.712.15.525.525 0 0 0-.208.694.525.525 0 0 0 .133.169c.163.16.373.265.6.3l.75.262c.34.07.644.256.863.525.172.211.265.477.262.75-.006.22-.057.438-.15.638a1.313 1.313 0 0 1-.413.487 1.125 1.125 0 0 1-.6.3c-.242.133-.511.21-.787.225ZM17.675 39.088c-1.8 1.312-4.425 2.025-6.675 2.025A12.037 12.037 0 0 1 2.825 38c-.188-.15 0-.375.187-.225a16.5 16.5 0 0 0 8.175 2.175 16.947 16.947 0 0 0 6.226-1.275c.3-.15.562.188.262.413Zm.75-.863c-.225-.3-1.538-.15-2.1-.075-.563.075-.225-.15-.075-.262 1.05-.713 2.738-.488 2.925-.263.188.225-.038 1.95-1.012 2.775-.15.113-.3.038-.226-.112.075-.15.713-1.763.488-2.063Z" />
    </g>
    <path
      fill="#111827"
      d="M35.12 28.2h7.483v7.482H35.12V28.2ZM43.383 28.2h7.481v7.482h-7.481V28.2ZM35.12 36.463h7.483v7.481H35.12v-7.481ZM43.383 36.463h7.481v7.481h-7.481v-7.481Z"
    />
    <g clipPath="url(#b)">
      <path
        fill="#111827"
        d="M9.263 7.687v2.85h4.087a4.088 4.088 0 0 1-4.087 3 4.538 4.538 0 1 1 2.962-7.987l2.1-2.1A7.5 7.5 0 1 0 9.263 16.5c6.3 0 7.687-5.887 7.087-8.813H9.263Z"
      />
    </g>
    <path
      fill="#111827"
      d="M42 13.859v2.983c5.057 0 8.986-4.882 7.333-10.184a7.472 7.472 0 0 0-4.875-4.875C39.165.13 34.283 4.067 34.283 9.116h2.983c0-3.167 3.141-5.617 6.476-4.41a4.472 4.472 0 0 1 2.668 2.668c1.215 3.332-1.237 6.47-4.401 6.476v-2.967h-2.976v2.976H42Z"
    />
    <path
      fill="#111827"
      d="M39.033 16.15h-2.292V13.86h2.292v2.292Zm-4.208-2.291h1.916v-1.917h-1.916v1.917Z"
    />
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M2 27.125h18v18H2z" />
      </clipPath>
      <clipPath id="b">
        <path fill="#fff" d="M0 0h18v18H0z" />
      </clipPath>
    </defs>
  </svg>
);

const SequinConnectDbIcon = memo(SvgComponent);
export default SequinConnectDbIcon;
